/* eslint-disable no-constant-condition */
import React from 'react'
import { TableCell, TableRow } from '@material-ui/core'
import { withStyles, createStyles } from '@material-ui/core/styles'
import { Colors } from '../../../../components/ColoredTableCell'
import { formatNumber } from '../../../../utils/Helpers'
import { LossesBase } from '../../../../types/Order'

type MainProps = {
  data: LossesBase[] | string[];
  title?: string;
  classNameValue?: string;
  classNameTitle?: string;
};

const StyledTableCell = withStyles(() => {
  const defaultStyle = {
    border: '1px #ffffff solid',
    minWidth: '180px',
    '&.left': {
      textAlign: 'left'
    },
    '&.center': {
      textAlign: 'center'
    },
    '&.right': {
      textAlign: 'right'
    },
    '&.titleRight': {
      textAlign: 'right'
    },
    '&.bold': {
      fontWeight: 'bold'
    },
    [`&.${Colors.red}`]: {
      color: '#dc3e44',
      backgroundColor: '#FFADB1'
    },
    [`&.${Colors.orange}`]: {
      color: '#EF6167',
      backgroundColor: '#FFDCDE'
    },
    [`&.${Colors.green}`]: {
      color: '#099461',
      backgroundColor: '#c7ebdb'
    },
    // [`&.${Colors.blue}`]: {
    //   color: '#2c693f',
    //   backgroundColor: '#7bc382'
    // }
    '&.blue': {
      backgroundColor: '#9ED6EE'
    },
    '& + td': {
      width: '400px'
    }
  }
  return createStyles({
    body: defaultStyle,
    head: defaultStyle
  })
})(TableCell)

const StickyTableCell = withStyles(() => {
  return createStyles({
    body: {
      border: '1px #ffffff solid',
      minWidth: '180px',
      '&.left': {
        textAlign: 'left'
      },
      '&.center': {
        textAlign: 'center'
      },
      '&.right': {
        textAlign: 'right'
      },
      '&.titleRight': {
        textAlign: 'right'
      },
      '&.bold': {
        fontWeight: 'bold'
      },
      [`&.${Colors.red}`]: {
        color: '#dc3e44',
        backgroundColor: '#ffa0a5'
      },
      [`&.${Colors.orange}`]: {
        color: '#EF6167',
        backgroundColor: '#ffc7ca'
      },
      [`&.${Colors.green}`]: {
        color: '#099461',
        backgroundColor: '#a6e7ca'
      },
      '&.blue': {
        backgroundColor: '#7dcaeb'
      },
      '& + td': {
        width: '400px',
        backgroundColor: '#fff'
      },
      width: '400px',
      backgroundColor: '#fff',
      left: -1,
      position: 'sticky',
      zIndex: 999
    },
    head: {
      border: '1px #ffffff solid',
      minWidth: '180px',
      '&:first-child': {
        width: '400px',
        backgroundColor: '#fff',
        left: -1,
        position: 'sticky',
        zIndex: 999
      }
    }
  })
})(TableCell)

export default function Row ({
  title,
  data,
  classNameValue,
  classNameTitle
}: MainProps): JSX.Element {
  return (
    <TableRow>
      <StickyTableCell className={classNameTitle}>
        {title}
      </StickyTableCell>
      {data.map((element) => {
        if (typeof element === 'string') {
          return (
            <StyledTableCell className={classNameValue}>
              {element}
            </StyledTableCell>
          )
        } else {
          return (
            <StyledTableCell className={classNameValue}>{`${formatNumber(
              element.quantity,
              0
            )} (R$ ${formatNumber(element.gmv, 2)})`}</StyledTableCell>
          )
        }
      })}
    </TableRow>
  )
}
